// extracted by mini-css-extract-plugin
export default {"sidenav":"Sidenav_sidenav__EUxvA"};